import { t } from '@sm/intl';

const COPY = {
  allbirds: {
    id: 'mrx.getLocalizedLogos.allbirds',
    defaultMessage: 'Allbirds company logo',
    description: '[Type: Label][Vis: low] - Labels Allbirds logo',
  },
  ibm: {
    id: 'mrx.getLocalizedLogos.ibm',
    defaultMessage: 'IBM company logo',
    description: '[Type: Label][Vis: low] - Labels IBM company logo',
  },
  just: {
    id: 'mrx.getLocalizedLogos.just',
    defaultMessage: 'JUST company logo',
    description: '[Type: Label][Vis: low] - Labels JUST company logo',
  },
  rj: {
    id: 'mrx.getLocalizedLogos.rj',
    defaultMessage: 'Raymond James company logo',
    description: '[Type: Label][Vis: low] - Labels Raymond James company logo',
  },
  tweezerman: {
    id: 'mrx.getLocalizedLogos.tweezerman',
    defaultMessage: 'Tweezerman company logo',
    description: '[Type: Label][Vis: low] - Labels Tweezerman company logo',
  },
};

const _getImage = (imgName, useBig) =>
  useBig ? import(`./images/${imgName}--lg.png`) : import(`./images/${imgName}.png`);

const getLocalizedLogos = async (locale = 'en_US', size = 'lg') => {
  const useBig = size === 'lg';
  const getImage = async imgName => (await _getImage(imgName, useBig)).default;

  if (locale === 'en_US') {
    return [
      {
        id: 'ibmLogo',
        name: t(COPY.ibm),
        image: await getImage('ibm_logo'),
      },
      {
        id: 'tweezermanLogo',
        name: t(COPY.tweezerman),
        image: await getImage('tweezerman_logo'),
      },

      {
        id: 'justLogo',
        name: t(COPY.just),
        image: await getImage('just_logo'),
      },
      {
        id: 'raymondJamesLogo',
        name: t(COPY.rj),
        image: await getImage('rj_logo'),
      },
      {
        id: 'allbirdsLogo',
        name: t(COPY.allbirds),
        image: await getImage('allbirds_logo'),
      },
    ];
  }
  return [];
};

export default getLocalizedLogos;
